// import ApiAuth from '@/api/auth'

export default {
  isLoggedIn () {
    // For the moment we only check the existence of a token, but we should verify the token by calling the API
    return (window.localStorage.getItem('token') != null)
    /* console.log('isLoggedIn call')
    ApiAuth.get.isLoggedIn().then(response => {
      console.log('isLoggedIn callback')
      return response
    }).catch(error => {
      console.log('shet happens')
      console.log(error)
    }) */
  }
}



// WEBPACK FOOTER //
// ./src/services/authService.js